<template>
  <div class="menubar">
    <va-sidebar
      theme="white"
      class="th-sidebar th-shadow-right sidebar-responsive"
      :compact="false"
      :text-links="false"
    >
      <div class="menu">
        <div class="section">
          <sidebar-group
            v-for="list in sidebarMenu1"
            :active="currentMenu === list.name"
            :key="list.key"
            :meta="list"
          ></sidebar-group>
        </div>
        <hr class="th-border" />
        <div class="section">
          <sidebar-group
            v-for="list in sidebarMenu2"
            :active="currentMenu === list.name"
            :key="list.key"
            :meta="list"
          ></sidebar-group>
        </div>
      </div>
      <div class="footer" v-if="sidebarIsExpanded">
        <hr class="th-border" />
        <div class="footer-content">
          <div class="footer-content-menu">
            <router-link @click.native="changeMenu" :to="{ name: 'Bantuan' }"
              ><div>Bantuan</div></router-link
            >
            <router-link
              @click.native="changeMenu"
              :to="{ name: 'Ketentuan Penggunaan' }"
              ><div>Ketentuan Penggunaan</div></router-link
            >
            <router-link
              @click.native="changeMenu"
              :to="{ name: 'Kebijakan Privasi' }"
              ><div>Kebijakan Privasi</div></router-link
            >
          </div>
          <!-- <div style="margin-bottom: 7px">
            <p>Yayasan Sahabat Umat Islam</p>
          </div> -->
          <div>
            <p>© 2021 Powered by TDS.</p>
            <p>All Rights Reserved</p>
          </div>
        </div>
      </div>
    </va-sidebar>
    <div class="th-shadow-top bottombar-responsive">
      <sidebar-group-mobile
        v-for="list in sidebarMenu1.concat(sidebarMenu2)"
        :active="currentMenu === list.name"
        :key="list.key"
        :meta="list"
      ></sidebar-group-mobile>
      <!-- <sidebar-group v-for="list in sidebarMenu2" :active="currentMenu === list.name" :key="list.key" :meta="list"></sidebar-group> -->
    </div>
  </div>
</template>
<script>
const SidebarGroup = () => import('@/components/App/Menus/SidebarGroup')
const SidebarGroupMobile = () => import('@/components/App/Menus/SidebarGroup/Mobile')
const sidebarMenu1 = [
  {
    key: 1,
    title: 'Beranda',
    icon: 'home',
    name: 'Utama',
  }, {
    key: 2,
    title: 'Temukan',
    icon: 'search',
    name: 'Temukan',
  },
]

const sidebarMenu2 = [
  {
    key: 3,
    title: 'Wishlist',
    icon: 'bookmark',
    name: 'Wishlist Saya',
    auth: true,
  },
  {
    key: 4,
    title: 'Course Saya',
    icon: 'screen',
    name: 'Course Saya',
    auth: true,
  },
]

export default {
  data() {
    return {
      sidebarMenu1,
      sidebarMenu2,
    }
  },
  components: {
    SidebarGroup,
    SidebarGroupMobile,
  },
  created () {
    const allMenu = this.sidebarMenu1.concat(this.sidebarMenu2)
    const router = this.$router.history.current
    for (let i = 0; i < allMenu.length; i++) {
      const menu = allMenu[i]
      if (router.name === menu.name) {
        this.$store.commit('SET_STATE', {
          currentMenu: menu.name,
        })
        break
      }
    }
    // console.log(this.$router.history.current.name)
  },
  computed: {
    currentMenu() { return this.$store.state.currentMenu },
    sidebarIsExpanded() { return this.$store.state.sidebarIsExpanded },
  },
  methods: {
    changeMenu() { this.$store.commit('SET_STATE', { currentMenu: '' }) },
  },
}
</script>

<style lang="scss">
@import "@/components/Kit/utils.scss";

.menubar {
  .bottombar-responsive {
    box-shadow: 0px -2px 2px $shadow1;
    @apply block md:hidden fixed bottom-0 left-0 z-10 w-full h-16 bg-white flex justify-around pr-2;
  }

  .th-sidebar {
    padding: 0;

    &.sidebar-responsive {
      @apply hidden md:block;
    }

    .va-sidebar-scrollarea {
      height: 100%;
      margin-top: 0px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      overflow: hidden;
      .menu {
        height: 100%;
        padding: 0 16px;
        overflow-y: auto;
        .section {
          margin: 20px 0;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(9, 30, 66, 0.32);
          border-radius: 5px;
        }
        &::-webkit-scrollbar-track {
          border-radius: 5px;
        }
        &::-webkit-scrollbar {
          width: 7px;
          height: 7px;
        }
      }

      .footer {
        bottom: 0;
        padding-bottom: 25px;
        background-color: #ffffff;
        &-content {
          padding: 20px 16px 0;
          color: $black-blue;
          div,
          p {
            font-size: 12px !important;
            color: $black;
          }

          // p {
          //   font-weight: 700!important;
          // }

          &-menu {
            margin-bottom: 10px;
            div {
              padding: 2px 0;
              color: $black;

              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
      }

      .menu,
      .footer {
        width: 100%;
      }
    }
  }
}
</style>
